import $ from 'jquery';
import TicketSelector from './TicketSelector';
import AdditionalEventsSelector from './AdditionalEventsSelector';

const { FieldValidationProvider } = window.tnew.lib;


class EventDetail {
  constructor(formSelector, ticketSelectorOptions) {
    this.ticketSelector = new TicketSelector(formSelector, ticketSelectorOptions);
    this.additionalEventsSelector = new AdditionalEventsSelector();

    const formId = formSelector.replace('#', '');

    FieldValidationProvider.createStandardProvider(formId);

    const $labels = $('.tn-detail-production-text-show-link, .tn-detail-production-text-hide-link');
    $('.tn-detail-production-text-toggle-link').on('click', () => {
      $labels.toggleClass('hide');
    });
  }
}

window.tnew.EventDetail = EventDetail;

export default EventDetail;



// WEBPACK FOOTER //
// ./V7/events/detail/EventDetail.js